import React, { Component, Fragment } from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';

import Grid from '../Grid/Grid';

function Adaptive(props) {
  const { initial = undefined, sm, md = undefined, lg = undefined, xl = undefined } = props;

  const isMounted = typeof window !== 'undefined';
  const breakpoints = { initial, sm, md: md || sm, lg: lg || md || sm, xl: xl || lg || md || sm };

  if (initial && !isMounted) return initial;
  return <Grid.ScreenClassRender render={(screenClass) => breakpoints[screenClass] || sm} />;
}

Adaptive.propTypes = {
  /** Rendered before the component has mounted (server side rendering) */
  initial: PropTypes.node /** Component rendered in small breakpoint */,
  sm: PropTypes.node.isRequired /** Component rendered in medium breakpoint */,
  md: PropTypes.node /** Component rendered in large breakpoint */,
  lg: PropTypes.node /** Component rendered in extralarge breakpoint */,
  xl: PropTypes.node
};

Adaptive.defaultProps = {
  initial: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined
};

export default Adaptive;
